export default function CoupounCardFloatDesktop(props: any) {
    return (
        <svg width="962" height="365" viewBox="0 0 962 365" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M124.597 187.164L111.918 186.733C111.088 186.705 110.481 187.509 110.736 188.301L113.322 196.329C113.575 197.114 114.526 197.416 115.186 196.92L125.278 189.322C126.182 188.641 125.728 187.202 124.597 187.164Z"
                fill="url(#paint0_linear_2364_35886)"
                stroke="url(#paint1_linear_2364_35886)"
                strokeWidth="0.4"
            />
            <circle
                cx="166.171"
                cy="51.1703"
                r="3.2"
                transform="rotate(-34.3971 166.171 51.1703)"
                fill="url(#paint2_linear_2364_35886)"
                stroke="url(#paint3_linear_2364_35886)"
                strokeWidth="0.4"
            />
            <circle
                cx="39.1702"
                cy="315.172"
                r="3.2"
                transform="rotate(-34.3971 39.1702 315.172)"
                fill="url(#paint4_linear_2364_35886)"
                stroke="url(#paint5_linear_2364_35886)"
                strokeWidth="0.4"
            />
            <path
                d="M593.272 147.376L627.503 138.17C628.305 137.955 628.651 137.008 628.176 136.326L614.708 116.984C614.236 116.307 613.238 116.297 612.752 116.964L591.99 145.511C591.324 146.427 592.179 147.67 593.272 147.376Z"
                fill="url(#paint6_linear_2364_35886)"
                stroke="url(#paint7_linear_2364_35886)"
                strokeWidth="0.4"
            />
            <circle
                cx="692.793"
                cy="56.6509"
                r="5.6227"
                transform="rotate(3.06982 692.793 56.6509)"
                fill="url(#paint8_linear_2364_35886)"
                stroke="url(#paint9_linear_2364_35886)"
                strokeWidth="0.4"
            />
            <circle
                cx="779.486"
                cy="297.315"
                r="4.35339"
                transform="rotate(3.06982 779.486 297.315)"
                fill="url(#paint10_linear_2364_35886)"
                stroke="url(#paint11_linear_2364_35886)"
                strokeWidth="0.4"
            />
            <circle
                cx="922.457"
                cy="172.315"
                r="4.35339"
                transform="rotate(3.06982 922.457 172.315)"
                fill="url(#paint12_linear_2364_35886)"
                stroke="url(#paint13_linear_2364_35886)"
                strokeWidth="0.4"
            />
            <circle
                cx="482.486"
                cy="116.311"
                r="4.35339"
                transform="rotate(3.06982 482.486 116.311)"
                fill="url(#paint14_linear_2364_35886)"
                stroke="url(#paint15_linear_2364_35886)"
                strokeWidth="0.4"
            />
            <path
                d="M588.035 234.259C588.184 233.99 588.171 233.668 588.06 233.335C587.948 233 587.73 232.627 587.426 232.226C586.819 231.421 585.839 230.461 584.572 229.411C582.034 227.307 578.311 224.812 574.002 222.419C569.693 220.027 565.606 218.186 562.479 217.144C560.917 216.624 559.585 216.3 558.581 216.209C558.079 216.164 557.647 216.176 557.304 216.258C556.962 216.34 556.683 216.499 556.533 216.768C556.383 217.038 556.396 217.359 556.508 217.693C556.62 218.027 556.838 218.4 557.141 218.802C557.749 219.607 558.729 220.566 559.996 221.616C562.534 223.72 566.257 226.215 570.566 228.608C574.875 231 578.962 232.841 582.088 233.883C583.65 234.403 584.982 234.728 585.987 234.818C586.489 234.863 586.921 234.851 587.263 234.769C587.606 234.687 587.885 234.529 588.035 234.259Z"
                fill="url(#paint16_linear_2364_35886)"
                stroke="url(#paint17_linear_2364_35886)"
                strokeWidth="0.4"
            />
            <defs>
                <linearGradient id="paint0_linear_2364_35886" x1="138.12" y1="189.817" x2="129.313" y2="206.622" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint1_linear_2364_35886" x1="131.912" y1="185.08" x2="133.989" y2="192.048" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint2_linear_2364_35886" x1="169.171" y1="44.6078" x2="173.861" y2="51.3645" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint3_linear_2364_35886" x1="165.755" y1="46.2857" x2="169.626" y2="46.4058" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint4_linear_2364_35886" x1="42.1702" y1="308.609" x2="46.86" y2="315.366" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint5_linear_2364_35886" x1="38.7539" y1="310.287" x2="42.6248" y2="310.407" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint6_linear_2364_35886" x1="564.886" y1="149.965" x2="573.114" y2="106.265" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint7_linear_2364_35886" x1="582.047" y1="156.33" x2="572.617" y2="142.135" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint8_linear_2364_35886" x1="698.216" y1="44.7887" x2="706.693" y2="57.0018" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint9_linear_2364_35886" x1="692.041" y1="47.8216" x2="699.038" y2="48.0387" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint10_linear_2364_35886" x1="783.639" y1="288.23" x2="790.132" y2="297.584" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint11_linear_2364_35886" x1="778.909" y1="290.553" x2="784.268" y2="290.719" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint12_linear_2364_35886" x1="926.611" y1="163.23" x2="933.104" y2="172.584" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint13_linear_2364_35886" x1="921.881" y1="165.553" x2="927.24" y2="165.719" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint14_linear_2364_35886" x1="486.639" y1="107.225" x2="493.132" y2="116.579" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint15_linear_2364_35886" x1="481.909" y1="109.548" x2="487.268" y2="109.714" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint16_linear_2364_35886" x1="539.832" y1="203.676" x2="550.629" y2="192.555" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint17_linear_2364_35886" x1="546.698" y1="211.837" x2="548.813" y2="208.079" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
            </defs>
        </svg>
    );
}
